import { ApolloClient, NormalizedCacheObject } from '@apollo/client'

import { SearchDocument } from 'hooks/useQueries'
import { deserializeSearchQuery } from 'actions/utils/search'

import { SEARCH_PAGE_SIZE } from './constants'

// Variables come from the same deserializeSearchQuery the consumer uses, so the
// seed shares its cache key. writeQuery is synchronous — safe in mini_racer SSR.
const seedSearchResults = (
  client: ApolloClient<NormalizedCacheObject>,
  searchResults: unknown,
  location: string,
): void => {
  if (!searchResults) return

  try {
    const queryIndex = location.indexOf('?')
    const queryString = queryIndex === -1 ? '' : location.slice(queryIndex)
    client.writeQuery({
      query: SearchDocument,
      variables: {
        pageSize: SEARCH_PAGE_SIZE,
        params: deserializeSearchQuery(queryString),
      },
      data: searchResults,
    })
  } catch {
    // Best-effort: a malformed payload must not break the render.
  }
}

export default seedSearchResults
